import { Box, Typography } from "@mui/material";
import HeroClip from "../app/HeroClip";
import NavBar from "../NavBar/NavBar";
import { useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import HeroCTA from "./subPages/HeroCTA";
import PressSlider from "./subPages/PressSlider";
import ServicesOverview from "./subPages/ServicesOverview";
import TalentDiscovery from "./subPages/TalentDiscovery";
import HowWeWork from "./subPages/HowWeWork";
import DancingWithStarsHeroBlock from "./subPages/DancingWithStarsHero";
import ContactStrip from "./subPages/ContactStrip";
import SEO from "../app/SEO";
import iconimg from "../images/pexels-pixabay-220836.jpg";

export default function HeroPage() {
  const [lightNav, setLightNav] = useState(true);
  const { t, i18n } = useTranslation("heropage");

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#F6F5F3",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SEO
        title="Helvetia Talent Agency | Celebrity Representation, Bookings & Fan Experiences"
        description="Helvetia manages celebrity talent, public personalities, and exclusive fan interactions including private events, meet and greets, digital shoutouts, and bespoke celebrity experiences."
        canonical={`https://helvieta.com/${i18n.language}/`}
        ogImage={iconimg}
      />
      <NavBar mode={lightNav ? "light" : "dark"} />

      {/* 1. Hero Video Section */}
      <HeroClip onVisibilityChange={setLightNav} />

      {/* Hero Headline Overlay */}
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: "15%", md: "10%" },
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "90%", md: "70%" },
          textAlign: "center",
        }}
      >
        <motion.div
          animate={{
            x: ["-0.5%", "0.5%", "-0.5%"],
            y: ["0%", "-0.5%", "0%"],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Lora', 'Playfair Display', serif",
              fontSize: { xs: "2rem", md: "3rem" },
              fontWeight: 700,
              color: "#FFFFFF",
              textShadow: "0 10px 30px rgba(0,0,0,0.7)",
              lineHeight: 1.1,
              wordWrap: "break-word",
            }}
          >
            {t("hero.title.prefix")}{" "}
            <motion.span
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1, ease: "easeOut" }}
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                color: "#C6A972",
                fontStyle: "italic",
                letterSpacing: "0.05em",
                textTransform: "capitalize",
              }}
            >
              {t("hero.title.highlight")}
            </motion.span>
          </Typography>
        </motion.div>
      </Box>

      {/* 2. Hero CTA */}
      <Box
        sx={{
          px: { xs: 2.5, md: 6 },
          py: { xs: 3, md: 5 },
        }}
      >
        <HeroCTA />
      </Box>

      {/* 3. Sections */}
      <PressSlider />
      <ServicesOverview />
      <DancingWithStarsHeroBlock />
      <TalentDiscovery />
      <HowWeWork />
      <ContactStrip />
    </Box>
  );
}
